import '@radix-ui/themes/styles.css';
import '.././styles/style.css';

const NewTheme: React.FC = () => <></>;

export default NewTheme;
